const getYear = () => {
  return new Date().getFullYear();
};
const isBefore = (date, dateToCompare) => {
  return date.getTime() < dateToCompare.getTime();
};
const isAfterOrEqualTo = (date, dateToCompare) => {
  return date.getTime() >= dateToCompare.getTime();
};
const getSeason = () => {
  const year = getYear();
  const today = new Date();
  const startOfSpring = new Date(year, 2, 1); // March
  const startOfSummer = new Date(year, 5, 1); // June
  const startOfFall = new Date(year, 8, 1); // September
  const startOfWinter = new Date(year, 11, 1); // December

  if (isAfterOrEqualTo(today, startOfSpring) && isBefore(today, startOfSummer)) {
    return 'Spring';
  } else if (isAfterOrEqualTo(today, startOfSummer) && isBefore(today, startOfFall)) {
    return 'Summer';
  } else if (isAfterOrEqualTo(today, startOfFall) && isBefore(today, startOfWinter)) {
    return 'Fall';
  }
  return 'Winter';
};
const getFullDate = () => {
  return `${getSeason()} ${getYear()}`;
};
module.exports = {
  getYear,
  isBefore,
  isAfterOrEqualTo,
  getSeason,
  getFullDate
};
